import 'whatwg-fetch';

export default class Quality {
	constructor(form) {
		this.form = form;

		this.checkbox = this.form.querySelector('input[type="checkbox"]');

		this.checkbox.addEventListener('change', event => {
			fetch(
				this.form.action, {
					method: this.form.method,
					credentials: 'same-origin',
					body: new FormData(this.form)
				}
			);

			if (event.target.checked) this.checkbox.analytics.send();
		});
	}
}
